import * as React from 'react';
import type { SVGProps } from 'react';
const SvgVideoCamera = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M15.114 9.357a.75.75 0 0 0 .772 1.286zM19.25 7.75H20a.75.75 0 0 0-1.136-.643zm0 8.5-.386.643A.75.75 0 0 0 20 16.25zm-3.364-2.893a.75.75 0 1 0-.772 1.286zm0-2.714 3.75-2.25-.772-1.286-3.75 2.25zM18.5 7.75v8.5H20v-8.5zm1.136 7.857-3.75-2.25-.772 1.286 3.75 2.25zM6.75 7.5h6.5V6h-6.5zm7.75 1.25v6.5H16v-6.5zm-1.25 7.75h-6.5V18h6.5zM5.5 15.25v-6.5H4v6.5zm1.25 1.25c-.69 0-1.25-.56-1.25-1.25H4A2.75 2.75 0 0 0 6.75 18zm7.75-1.25c0 .69-.56 1.25-1.25 1.25V18A2.75 2.75 0 0 0 16 15.25zM13.25 7.5c.69 0 1.25.56 1.25 1.25H16A2.75 2.75 0 0 0 13.25 6zM6.75 6A2.75 2.75 0 0 0 4 8.75h1.5c0-.69.56-1.25 1.25-1.25z"
    />
  </svg>
);
export default SvgVideoCamera;
